import { CustomThemeOptions } from '../themeTypes';

export default {
  custom: {
    app: {
      padding: '10px 3px 3px',
    },
    pages: {
      login: {
        hideDirections: true,
      },
    },
  },
  typography: {
    h1: {
      alignSelf: 'flex-start',
      marginTop: 4,
      marginBottom: 12,
      color: '#444',
      fontSize: 20,
      fontWeight: 700,
      lineHeight: '22px',
    },
    subtitle1: {
      fontSize: 14,
      color: '#444',
      alignSelf: 'flex-start',
      textAlign: 'left',
    },
    body2: {
      marginTop: 0,
    },
  },
  palette: {
    primary: {
      main: '#0098cd',
    },
  },
  props: {
    MuiButton: {
      fullWidth: false,
    },
    MuiGrid: {
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        height: 'auto',
        fontSize: 14,
        fontWeight: 400,
        borderRadius: 5,
        textTransform: 'none',
        '&:active': {
          boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.1), 0 0 8px rgba(82, 169, 236, 0.6)',
        },
        '&:focus': {
          '&::before': {
            display: 'none',
          },
        },
        '&$focusVisible': {
          boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.1), 0 0 8px rgba(82, 169, 236, 0.6)',
        },
      },
      containedPrimary: {
        '&:hover': {
          backgroundColor: '#00729a',
        },
        marginRight: 'auto',
      },
    },
    MuiOutlinedInput: {
      root: {
        height: 38,
        backgroundColor: '#fff',
        '&$focused $notchedOutline': {
          borderColor: 'rgba(82, 169, 236, 0.8)',
          boxShadow: 'inset 0 1px 1px rgba(0, 0, 0, 0.1), 0 0 8px rgba(82, 169, 236, 0.6)',
        },
        '&:hover $notchedOutline': {
          borderColor: '#bebfbf',
        },
      },
      notchedOutline: {
        borderColor: '#bebfbf',
      },
      input: {
        padding: '10px',
      },
    },
    MuiLink: {
      root: {
        color: '#0098cd',
        '&:hover': {
          color: '#00729a',
        },
      },
    },
    MuiInputLabel: {
      root: {
        marginBottom: 5,
        lineHeight: 1.2,
        fontSize: 12,
        color: '#666',
      },
    },
  },
} as CustomThemeOptions;
